/**
 * Removes B2C's logout echo from the address bar before anything reads it.
 *
 * B2C sends the browser back to `postLogoutRedirectUri` with MSAL's logout `state` appended as a query
 * parameter (`/?state=...`). msal-angular captures the page path when MsalService is created and hands it
 * to MSAL as if it were a response hash; MSAL accepts anything carrying `state` as a sign-in response and
 * fails with `state_mismatch`, discarding the real sign-in that was started from that page, which then
 * restarts in a loop. The app never uses a `state` query parameter itself, and real sign-in responses
 * arrive in the URL fragment, which is left untouched.
 *
 * Must run before Angular bootstraps (see main.ts).
 */
export function removeStrayStateQueryParameter(): void {
  const query = new URLSearchParams(window.location.search);
  if (!query.has('state') || query.has('code') || query.has('error')) {
    return;
  }
  query.delete('state');
  const search = query.toString();
  window.history.replaceState(null, '', `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`);
}
